import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Button from '@material-ui/core/Button';
import { authenticationService } from '../../../Services/authentication.service';
import { FormikTextField } from 'formik-material-fields';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { defaultAuthenticationErrorMessage } from '../../../Config/constants'

export default function LoginPage(props) {
    let history = useHistory();
    useEffect(() => {
        // redirect to home if already logged in
        if (props.user.userToken !== null && props.user.userToken !== undefined && props.user.userToken !== "") {
            if (props.nav.currentURL !== '/login') {
                history.push(props.nav.currentURL)
            }
        }
    }, []);

    const classes = useStyles();
    const { t } = useTranslation();

    const submitLoginForm = ({ username, password }, { setStatus, setSubmitting }) => {
        setStatus();
        setSubmitting(true);

        props.actions.setUserToken("demo")
        props.actions.setUserInfo({ sub: "demo" })

        if (props.nav.currentURL !== undefined && props.nav.currentURL !== "/login") {
            history.push(props.nav.currentURL)
        }
        else {
            history.push('/')
        }

        // authenticationService.login(username, password)
        //     .then(
        //         loginResult => {

        //             props.actions.setUserToken(loginResult.access_token)
        //             props.actions.setUserInfo({ sub: username })

        //             if(props.nav.currentURL !== undefined && props.nav.currentURL !== "/login"){
        //                 history.push(props.nav.currentURL)
        //             }
        //             else{
        //                 history.push('/')
        //             }
        //             // authenticationService.userInfo(loginResult.access_token).then(info => {

        //             //     props.actions.setUserInfo(info)
        //             // }, error => {
        //             //     setStatus(error);
        //             //     setSubmitting(false);
        //             // })
        //         },
        //         error => {
        //             setStatus(error);
        //             setSubmitting(false);
        //         }
        //     );
    };

    return <div className={classes.background}>
        <div className="spacer100" style={{ height: "150px" }}></div>
        <Formik
            initialValues={{
                username: '',
                password: ''
            }}
            validationSchema={Yup.object().shape({
                username: Yup.string().required('Username is required'),
                password: Yup.string().required('Password is required')
            })}
            onSubmit={submitLoginForm}>
            {({ errors, status, touched, isSubmitting }) => {
                let wrongLogin = status && status.includes(defaultAuthenticationErrorMessage)
                return (
                    <div className={classes.signUpContainer}>
                        <div className={classes.smart}>
                            SMART
                        </div>
                        <div className={classes.production}>
                            PRODUCTION
                        </div>
                        <div className={classes.signUpHeader} >
                            <div className={classes.signUpHeaderTitle}>
                                {'Login'}
                            </div>
                            <div className={classes.signUpHeaderSubTitle}>
                                {'Enter your details below to continue'}
                            </div>
                        </div>
                        <div className={classes.signUpFormContainer}>
                            <Form>
                                <div className={classes.label}>Username</div>
                                <div className="form-group">
                                    <FormikTextField
                                        id="outlined-search"
                                        type="search"
                                        variant="outlined"
                                        name="username"
                                        size="small"
                                        fullWidth
                                        className={classes.uiTextField}
                                        InputProps={{
                                            className: classes.input,
                                        }}
                                        style={{ border: wrongLogin && "2px solid #F90829", borderRadius: wrongLogin && "5px" }}
                                    />
                                </div>
                                <div className={classes.label}>Password</div>
                                <div className="form-group">
                                    <FormikTextField
                                        id="outlined-search"
                                        type="password"
                                        variant="outlined"
                                        name="password"
                                        size="small"
                                        fullWidth
                                        className={classes.uiTextField}
                                        style={{ border: wrongLogin && "2px solid #F90829", borderRadius: wrongLogin && "5px" }}
                                    />
                                </div>
                                {wrongLogin &&
                                    <div className={classes.authenticationErrorMessage}>{defaultAuthenticationErrorMessage}</div>
                                }
                                <div className={classes.loginButtonContainer}>
                                    <Button fullWidth variant="contained" color="primary" type="submit" className={classes.loginButton} disabled={isSubmitting}>
                                        {isSubmitting ?
                                            <div className={classes.centeredContent}>
                                                <img alt='loading' src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                            </div> : <div className="whiteText">{t('Login')}</div>
                                        }
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                )
            }}
        </Formik>
    </div>
}

const useStyles = makeStyles({


    signUpContainer: {
        width: '350px',
        height: "340px",
        margin: 'auto',
        backgroundColor: '#F6F6F6',
        borderRadius: '5px',
        paddingRight: "60px",
        paddingLeft: "60px",
        paddingBottom: "20px",
        boxShadow: "0 0 15px 5px rgba(0,0,0,0.15)",
    },

    signUpHeader: {
        height: '80px',
    },

    signUpHeaderTitle: {
        paddingTop: '8px',
        color: "#020100",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginBottom: "5px"
    },
    signUpHeaderSubTitle: {
        color: "#8D8D8D",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    },

    signUpFormContainer: {

    },

    centeredContent: {
        justifyContent: 'center',
        alignContent: 'center'
    },

    loginButton: {
        height: "40px !important",
        width: "160px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    },

    loginButtonContainer: {
        width: "100%",
        textAlign: "center",
        marginTop: "20px"
    },

    uiTextField: {
        width: "100%",
        backgroundColor: "white",
        marginBottom: "15px",
        maxHeight:"40px",
        "& .MuiFormHelperText-root.Mui-error": {
            backgroundColor: "rgb(1,1,1,0)",
            display:"contents",
        },
    },    

    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        textAlign: "left"
    },

    smart: {
        display: 'block',
        fontSize: "26px",
        fontFamily: "Campton-bold",
        color: "#4654FF",
        height: "23px",
        marginTop: "5px",
        width: "100%",
        marginLeft: "90px",
        position: "relative",
        bottom: "30px",
        letterSpacing: "-1"
    },
    production: {
        display: 'block',
        fontSize: "26px",
        fontFamily: "Campton-bold",
        color: "#000000",
        height: "23px",
        width: "100%",
        marginLeft: "90px",
        position: "relative",
        bottom: "30px",
        letterSpacing: "-1"
    },
});